import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Instance, getNodeId } from 'mobx-state-tree'
import { Stack } from '@mui/material'

import { useStores } from '@trivie/core'
import { Text } from '@trivie/ui-web/components/text'
import { color } from '@trivie/ui-web/theme'
import { Quiz } from '@trivie/core/src/models/Quiz'

import { ReactComponent as NullState } from '../null-states/null-quiz-settings.svg'
import { QuizItem } from './quiz-item'

export const QuizList = observer((props: any) => {
  const { importing, quizzes, style, existingQuizNames } = props
  const { contentCreationStore } = useStores()
  const { selectedTopic } = contentCreationStore

  const [draggingQuizID, setDraggingQuizID] = useState<null | number>(null)
  const [hoveredID, setHoveredID] = useState<null | number>(null)
  const [grabbing, setGrabbing] = useState(false)

  const handleDrag = (quiz: Instance<typeof Quiz>) => setDraggingQuizID(getNodeId(quiz))

  const handleDrop = (quiz: Instance<typeof Quiz>) => {
    setGrabbing(false)
    if (selectedTopic) {
      const { quizzes } = selectedTopic
      const dragQuiz = quizzes?.find((c) => getNodeId(c) === draggingQuizID)
      const dropQuiz = quizzes?.find((c) => getNodeId(c) === getNodeId(quiz))
      if (dragQuiz && dropQuiz) {
        selectedTopic.reorderQuizzes(
          quizzes?.indexOf(dragQuiz) ?? 0,
          quizzes?.indexOf(dropQuiz) ?? 0,
        )
      }
    }
  }

  if (!selectedTopic && quizzes?.length === 0) {
    return null
  }

  const data = selectedTopic ? selectedTopic?.quizzes : quizzes

  return data?.length === 0 ? (
    <>
      <NullState style={{ alignSelf: 'center' }} />
      <Text
        align="center"
        alignSelf="center"
        color={color.shade50}
        my={'16px'}
        text="You don't have any quizzes attached this topic yet! Add a quiz to get rolling."
      />
    </>
  ) : (
    <Stack useFlexGap gap={2} style={style}>
      {data?.map((q: Instance<typeof Quiz>) => {
        return (
          <QuizItem
            importing={importing}
            // hideDrag
            existingQuizNames={existingQuizNames}
            grabbing={grabbing}
            handleDrag={handleDrag}
            handleDrop={handleDrop}
            setHoveredID={setHoveredID}
            setGrabbing={setGrabbing}
            hoveredID={hoveredID}
            quiz={q}
          />
        )
      })}
    </Stack>
  )
})
